import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { MetaTagComponent, MetaTags } from '../utils/MetaTags';

export default function Services(props) {
  return (
    <>
      <MetaTagComponent 
        pageTitle={MetaTags.services.title}
        pageDescription={MetaTags.services.description}
        pageKeywords={MetaTags.services.keywords}
      />
      <Header />
      <div>
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div className="breadcrumb-section mb-120">
              <div className="container mb-70">
                <div className="row">
                  <div className="col-xl-8 col-lg-10">
                    <div className="breadcrumb-content">
                      <ul className="breadcrumb-list">
                        <li>
                          <a href="service-details.html#">Home</a>
                        </li>
                        <li>
                          <svg
                            width="24"
                            height="6"
                            viewBox="0 0 24 6"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05L-3.26633e-05 2.88672ZM23.7735 2.88672L20.8867 -3.26633e-05L18 2.88672L20.8867 5.77347L23.7735 2.88672ZM2.88672 2.88672V3.38672H20.8867V2.88672V2.38672H2.88672V2.88672Z" />
                          </svg>
                          Product Development
                        </li>
                      </ul>
                      <h1>Solutions That Drive Real Business Growth</h1>
                      <div className="para">
                        <div className="icon">
                          <svg
                            width="6"
                            height="49"
                            viewBox="0 0 6 49"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M2.88672 -3.26633e-05L-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05ZM2.88672 48.7735L5.77347 45.8867L2.88672 43L-3.26633e-05 45.8867L2.88672 48.7735ZM2.88672 2.88672H2.38672L2.38672 45.8867H2.88672H3.38672L3.38672 2.88672H2.88672Z" />
                          </svg>
                        </div>
                        <p>
                          {" "}
                          From design and development to marketing and branding,
                          we ensure every service is crafted to meet your unique
                          goals.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="service-details-page mb-120">
              <div className="container-fluid">
                <div className="row mb-70">
                  <div className="col-lg-12 d-flex justify-content-center">
                    <div className="service-details-thumb-img">
                      <img
                        src="assets/image/innerpage/service-details-tumb-img.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="service-details-content-wrap">
                      <div className="row mb-40">
                        <div className="col-lg-12">
                          <div className="service-details-title">
                            <h2>Product Development Services</h2>
                          </div>
                        </div>
                      </div>
                      <div className="row gy-4 mb-80">
                        <div className="col-lg-6">
                          <div className="details-content">
                            <h3>Service Overview:</h3>
                            <p>
                              We help businesses turn ideas into successful
                              products by combining design, technology, and
                              strategy. From concept to launch, our product
                              development services cover the entire lifecycle,
                              ensuring innovative, scalable, and market-ready
                              solutions tailored to your business goals.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-lg-center">
                          <div className="details-content">
                            <h3> Our Approach:</h3>
                            <ul className="approach-list">
                              <li>Discover & Research</li>
                              <li>Strategy & Planning</li>
                              <li>Execution & Optimization</li>
                              <li>Measure & Scale</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="row gy-4 mb-80">
                        <div className="col-lg-3 col-md-6">
                          <div className="service-details-img">
                            <img
                              src="assets/image/innerpage/service-details-img.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="service-details-img">
                            <img
                              src="assets/image/innerpage/service-details-img2.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="service-details-img">
                            <img
                              src="assets/image/innerpage/service-details-img3.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mb-70">
                        <div className="col-lg-12">
                          <div className="service-details-title mb-20">
                            <h2>Key Features:</h2>
                          </div>
                          <div className="key-features-area">
                            <ul className="key-features-list">
                              <li>End-to-End Development </li>
                              <li className="two">User Cantered Design</li>
                              <li className="three">Agile Methodology</li>
                              <li className="two">Scalable Architecture</li>
                              <li className="four">Security Reliability </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-80">
                        <div className="col-lg-12">
                          <div className="service-details-title mb-40">
                            <h2>Why Choose Us:</h2>
                          </div>
                          <div className="why-choose-area-wrap">
                            <div className="row g-0">
                              <div className="col-lg-6">
                                <div className="why-choose-area">
                                  <ul className="why-choose-list">
                                    <li>
                                      <div className="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div className="content">
                                        <p>
                                          <span>Proven Expertise –</span>{" "}
                                          Experienced team with a track record
                                          of successful product launches.
                                        </p>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div className="content">
                                        <p>
                                          <span>Client-Centric Approach –</span>{" "}
                                          Your goals, challenges, and users are
                                          always our priority.
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="why-choose-area">
                                  <ul className="why-choose-list">
                                    <li className="justify-content-lg-end">
                                      <div className="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div className="content">
                                        <p>
                                          <span>Innovation-Driven –</span> We
                                          bring creativity and cutting-edge
                                          technology to every project.
                                        </p>
                                      </div>
                                    </li>
                                    <li className="justify-content-lg-end">
                                      <div className="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div className="content">
                                        <p>
                                          <span>Transparent Process –</span>{" "}
                                          Open communication, regular updates,
                                          and collaborative workflow.
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row gy-4">
                        <div className="col-lg-3 col-md-6" style={{ order: 1 }}>
                          <div className="service-details-img">
                            <img
                              src="/assets/image/innerpage/service-details-img4.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-6" style={{ order: 3 }}>
                          <div className="service-details-img">
                            <img
                              src="/assets/image/innerpage/service-details-img5.png"
                              alt=""
                            />
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6" style={{ order: 2 }}>
                          <div className="service-details-img">
                            <img
                              src="/assets/image/innerpage/service-details-img6.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
